function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded), sourceSymbolKeys; var key, i; if (Object.getOwnPropertySymbols) { sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { SvgIcon } from "./SvgIcon";
var mediumPath = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("foreignObject", {
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    width: "100%",
    height: "100%",
    background: "conic-gradient(from 90deg, #1390DD 5%, #ED2324 25.7%, #E59F1C 47.6%, #5ABA47 75%)"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "lighten"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#111",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.98",
  d: "M11.27 5.97H4.32v13.883h13.863V12.9"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#111",
  strokeLinecap: "round",
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: ".99"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: ".99",
  d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
})));
var mediumPathDark = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("foreignObject", {
  x: "0",
  y: "0",
  width: "24",
  height: "24"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    width: "100%",
    height: "100%",
    background: "conic-gradient(from 90deg, #1390DD 5%, #ED2324 25.7%, #E59F1C 47.6%, #5ABA47 75%)"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "darken"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.98",
  d: "M11.27 5.97H4.32v13.883h13.863V12.9"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: ".99"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: ".99",
  d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
})));
var largePath = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("foreignObject", {
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    width: "100%",
    height: "100%",
    background: "conic-gradient(from 90deg, #1390DD 5%, #ED2324 25.7%, #E59F1C 47.6%, #5ABA47 75%)"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "lighten"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#111",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3.96",
  d: "M21.54 12.94H7.64v27.765h27.726V26.801"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#111",
  strokeLinecap: "round",
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: "1.98"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
})));
var largePathDark = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("foreignObject", {
  x: "0",
  y: "0",
  width: "48",
  height: "48"
}, /*#__PURE__*/React.createElement("div", {
  style: {
    width: "100%",
    height: "100%",
    background: "conic-gradient(from 90deg, #1390DD 5%, #ED2324 25.7%, #E59F1C 47.6%, #5ABA47 75%)"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "darken"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#111",
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "3.96",
  d: "M21.54 12.94H7.64v27.765h27.726V26.801"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: "1.98"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
})));
export var NBY = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? "light" : _ref$background,
      rest = _objectWithoutProperties(_ref, ["background"]);

  var isLight = background === "light";
  var paths = {
    s: isLight ? mediumPath : mediumPathDark,
    m: isLight ? mediumPath : mediumPathDark,
    l: isLight ? largePath : largePathDark
  };
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    paths: paths
  }, rest));
});
NBY.displayName = "NBY";